var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentsSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.5C19.8995 12.5 22.25 10.1495 22.25 7.25C22.25 4.35051 19.8995 2 17 2C14.1005 2 11.75 4.35051 11.75 7.25C11.75 10.1495 14.1005 12.5 17 12.5Z",
    stroke: "#274137",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 29.75C2 23.1223 8.04425 17.75 15.5 17.75",
    stroke: "#274137",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 31.25C28.2279 31.25 31.25 28.2279 31.25 24.5C31.25 20.7721 28.2279 17.75 24.5 17.75C20.7721 17.75 17.75 20.7721 17.75 24.5C17.75 28.2279 20.7721 31.25 24.5 31.25Z",
    stroke: "#274137",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 22.25V25.25H26.75",
    stroke: "#274137",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsSystemIcon);
export default __webpack_public_path__ + "static/media/appointments_systemIcon.f331e4db7908fdb58b5ddb5fab4ca004.svg";
export { ForwardRef as ReactComponent };